<template>
  <div>
    <template v-if="onlyCopyright">
      <div class="container_fluid phone footer-phone">
        <div class="col-ms-12" style="width: 272px; margin: auto;">
          <router-link class="navbar-brand" to="/">
            <img src="../../assets/img/logo_light_gray.svg" alt="Финсайт" />
          </router-link>
          <p class="copyright">
            © Любое использование либо копирование материалов сайта,
            элементов дизайна и оформления допускается лишь с письменного
            разрешения правообладателя и при указании ссылки на
            первоисточник Финсайт
          </p>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="container_fluid pc footer-pc">
        <div class="container">
          <div class="row row-full-width footer">
            <div class="col-xs-3 col-sm-3 col-md-3">
              <ul>
                <router-link class="navbar-brand" to="/">
                  <img src="../../assets/img/logo_gray.svg?v=2" alt="Финсайт" />
                </router-link>
                <p class="copyright">
                  © Любое использование либо копирование материалов сайта,
                  элементов дизайна и оформления допускается лишь с письменного
                  разрешения правообладателя и при указании ссылки на
                  первоисточник Финсайт
                </p>
              </ul>
            </div>
            <div class="col-xs-2 col-sm-2 col-md-3 navigations">
              <h6>Редакция</h6>
              <ul>
                <li><a href="/about">О сервисе</a></li>
                <li><a href="/feedback">Контакты</a></li>
                <li><a rel="nofollow" href="/oferta.pdf">Оферта</a></li>
                <li><a href="/privacy">Политика конфиденциальности</a></li>
              </ul>
            </div>
            <div class="col-xs-2 col-sm-2 col-md-3 navigations">
              <h6>Рубрики</h6>
              <ul>
                <li><router-link to="/category/lifehacks">Лайфхаки</router-link></li>
                <li><router-link to="/category/knowledge">Знания</router-link></li>
                <li><router-link to="/category/tests">Тесты</router-link></li>
                <li><router-link to="/category/reviews">Ревью</router-link></li>
              </ul>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-3 navigations">
              <h6>Сервисы</h6>
              <ul>
                <li><router-link to="/journal">Журнал</router-link></li>

                <template v-if="invType">
                  <template v-if="invType === 1">
                    <li><router-link :class="{ active: section === '/investments' }"
                        to="/investments">Инвестиции</router-link>
                    </li>
                  </template>
                  <template v-else>
                    <li><router-link :class="{ active: section === '/landing-invest' }"
                        to="/landing-invest">Инвестиции</router-link>
                    </li>
                  </template>
                </template>
                <template v-else>
                  <li><router-link to="/login-invest">Инвестиции</router-link>
                  </li>
                </template>
                <li><a href="https://t.me/Finsite_bot" target="_blank">Консультации</a></li>
              </ul>
            </div>
            <div class="col-xs-2 col-sm-12 col-md-2" v-if="false">
              <ul>
                <li>Документы</li>
                <li><a rel="nofollow" href="/oferta.pdf">Оферта</a></li>
                <li><a href="/privacy">Политика конфиденциальности</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="container_fluid phone footer-phone">
        <div class="container">
          <div class=" row-full-width footer ">
            <div class="col col-ms-6">
              <ul>
                <h6 class="footer-subtitle">Сервисы</h6>
                <li><router-link to="/journal">Журнал</router-link></li>
                <template v-if="invType">
                  <template v-if="invType === 1">
                    <li><router-link :class="{ active: section === '/investments' }"
                        to="/investments">Инвестиции</router-link>
                    </li>
                  </template>
                  <template v-else>
                    <li><router-link :class="{ active: section === '/landing-invest' }"
                        to="/landing-invest">Инвестиции</router-link>
                    </li>
                  </template>
                </template>
                <template v-else>
                  <li><router-link to="/login-invest">Инвестиции</router-link>
                  </li>
                </template>
                <li><a href="https://t.me/Finsite_bot" target="_blank">Консультации</a></li>
              </ul>
            </div>
            <div class="col col-ms-6">
              <ul>
                <h6 class="footer-subtitle">Рубрики</h6>
                <li><router-link to="/category/lifehacks">Лайфхаки</router-link></li>
                <li><router-link to="/category/knowledge">Знания</router-link></li>
                <li><router-link to="/category/test">Тесты</router-link></li>
                <li><router-link to="/category/reviews">Ревью</router-link></li>
              </ul>
            </div>
          </div>
          <div class="row-full-width footer ">
            <div class="col col-ms-6">
              <ul>
                <h6 class="footer-subtitle">Редакция</h6>
                <li><a href="/about">О сервисе</a></li>
                <li><a href="/feedback">Контакты</a></li>
                <li><a rel="nofollow" href="/oferta.pdf">Оферта</a></li>
                <li><a href="/privacy">Политика<br> конфиденциальности</a></li>
              </ul>
            </div>
          </div>
          <div>
            <div class="col col-ms-6" v-if="false">
              <ul>
                <h6 class="footer-subtitle">Документы</h6>
                <li><a rel="nofollow" href="/oferta.pdf">Оферта</a></li>
                <li><a href="/privacy">Политика конфиден-<br />циальности</a></li>
              </ul>
            </div>
            <div class="col-ms-12 mt-5">
              <router-link class="navbar-brand" to="/">
                <img src="../../assets/img/logo_light_gray.svg" alt="Финсайт" />
              </router-link>
              <p class="copyright">
                © Любое использование либо копирование материалов сайта,
                элементов дизайна и оформления допускается лишь с письменного
                разрешения правообладателя и при указании ссылки на
                первоисточник Финсайт
              </p>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>

export default {
  props: {
    onlyCopyright: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return { section: null }
  },
  computed: {
    invType() {
      return this.$store.state.user?.payment?.inv_type;
    }
  },
}
</script>
<style scoped>
.footer {
  display: flex;
  margin: 0;
}

.col.col-ms-6 {
  padding: 0;
}

.phone .navbar-brand {
  margin-bottom: 20px;
}

.pc .copyright {
  width: 307px;

}

.phone .copyright {
  font-family: 'Circe';
  text-align: center;
  font-weight: normal;
  font-size: 10px;
  line-height: 11px;
  color: #828282;
}
</style>
